module.exports = [
  '$ngRedux',
  '$rootScope',
  '$state',
  'SessionService',
  'SecurityService',

  function SecurityListener($ngRedux, $rootScope, $state, SessionService, SecurityService) {
    SecurityService.poll();

    $rootScope.$on('application:out', (event, params) => {
      let isAccount = SessionService.isAccountLoggedIn() ? true : $state.includes('kiosk');

      SessionService.reset();

      SecurityService.logout();

      // Retrieve current group from session
      let currentGroupId = $ngRedux.getState().group.id;

      if (!currentGroupId && params && params.groupId) {
        currentGroupId = +params.groupId;
      }

      // No need to redirect if unauthenticated, and current route requires no authentication
      if (currentGroupId && !$state.current.insecure) {
        const loginRoute = isAccount ? 'kiosk.login' : 'login';

        $state.go(loginRoute, { locale: $ngRedux.getState().locale, groupId: currentGroupId, error: params && params.error });
      }
    });
  },
];



// WEBPACK FOOTER //
// ./main/config/listeners/security.js